import React, { useEffect, useRef, useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  LineController,TimeScale
} from 'chart.js';
import 'chartjs-adapter-date-fns';
const LiveCollectionCharts = ({ spendPerWeek,spendPerDay ,collections }) => {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    LineController,TimeScale
  );
  const [profitLoss,setProfitLoss]= useState(0);
  const [cost,setCost]=useState(0);
  const [periode,setPeriode]=useState("ThisMonth")
  const [selectedCollection, setSelectedCollection] = useState(null);
  const chartRef = useRef(null);
   

  const [chartData, setChartData] = useState({
    labels: spendPerWeek.map((entry) => entry.DateSaved),
    datasets: [
      {
        label: 'Total Value',
        data: spendPerWeek.map((entry) => entry.TotalValue),
        fill: false,
        borderColor: 'rgba(75, 192, 192, 1)',
      },
    ],
  });

  function InitialiseCharts (){

    const TotalValueDataset = {
      label: 'Total Value',
      data: spendPerWeek.map((entry) => entry.TotalValue),
      fill: false,
      borderColor: 'rgba(75, 192, 192, 1)',
    };
  
    const costDataset = {
      label: 'Total Cost',
      data: spendPerWeek.map((entry) => entry.TotalCost), // Assuming this is the property for paid price
      fill: false,
      borderColor: 'rgba(192, 75, 75, 1)', // You can choose a different color
    };

    setChartData({
      labels: spendPerWeek.map((entry) => entry.DateSaved),
      datasets: [TotalValueDataset, costDataset],
    });
  }

  function InitialiseProfitLastThisMonths ()
  {
    const currentDate = new Date('2024-02-03');
    const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

  // Filter data based on the date range (from startDate to currentDate)
 const filteredData = spendPerDay.filter((entry) => {
    const entryDate = new Date(entry.DateSaved);
    return entryDate >= startDate && entryDate <= currentDate;
  });

  const firstIndex = 0;
  const lastIndex = filteredData.length - 1;
  setProfitLoss(filteredData[lastIndex].TotalValue - filteredData[firstIndex].TotalValue)
  setCost(filteredData[lastIndex].TotalCost - filteredData[firstIndex].TotalCost)
}



useEffect(()=>{
InitialiseProfitLastThisMonths();
InitialiseCharts();
},[])


  const options = {
    scales: {
      x: {
        type: 'time',
        time: {
          unit: 'day',
        },
      },
      y: {
        beginAtZero: true,
      },
    },
  };


  let myChart = null;

  useEffect(() => {
    const ctx = chartRef.current.getContext('2d');

    if (myChart) {
      // If a chart instance already exists, destroy it
      myChart.destroy();
    }

    // Create a new chart instance with updated data
    myChart = new ChartJS(ctx, {
      type: 'line',
      data: chartData,
      options: options,
    });

    return () => {
      if (myChart) {
        myChart.destroy();
      }
    };
  }, [chartData]);

  const handleCollectionChange = (event) => {
    const selectedValue = event.target.value;

    if (selectedValue === '') {
      // Show the global state by resetting the data

      const TotalValueDataset = {
        label: 'Total Value',
        data: spendPerWeek.map((entry) => entry.TotalValue),
        fill: false,
        borderColor: 'rgba(75, 192, 192, 1)',
      };
    
      const costDataset = {
        label: 'Total Cost',
        data: spendPerWeek.map((entry) => entry.TotalCost), // Assuming this is the property for paid price
        fill: false,
        borderColor: 'rgba(192, 75, 75, 1)', // You can choose a different color
      };

      setChartData({
        labels: spendPerWeek.map((entry) => entry.DateSaved),
        datasets: [TotalValueDataset, costDataset],
      });

    } else {
      const selectedCollection = collections.find(
        (collection) => collection.id === parseInt(selectedValue)
      );


      const TotalValueDataset = {
        label: 'Total Value',
        data: spendPerWeek
        .filter((entry) => selectedCollection.items.includes(entry.GraphId))
        .map((entry) => entry.TotalValue),
        fill: false,
        borderColor: 'rgba(75, 192, 192, 1)',
      };
    
      const costDataset = {
        label: 'Total Cost',
        data: spendPerWeek
        .filter((entry) => selectedCollection.items.includes(entry.GraphId))
        .map((entry) => entry.TotalCost), // Assuming this is the property for paid price
        fill: false,
        borderColor: 'rgba(192, 75, 75, 1)', // You can choose a different color
      };

      setChartData({
        labels: spendPerWeek.map((entry) => entry.DateSaved),
        datasets: [TotalValueDataset, costDataset],
      });
    }

    setSelectedCollection(selectedValue);
  };

  
  

  const filterData = (timeFrame) => {
    // Implement logic to filter data based on the selected time frame
    // For example, if timeFrame is 'Last Week', filter data for the past week
    // Update the chart data with the filtered data
// Get the current date
const currentDate = new Date('2024-02-03');
const startDate = new Date(currentDate);

let filteredData;

if(timeFrame === '7 days')
{
  startDate.setDate(currentDate.getDate() - 7);
  // Filter data based on the date range (from startDate to currentDate)
 filteredData = spendPerDay.filter((entry) => {
    const entryDate = new Date(entry.DateSaved);
    return entryDate >= startDate && entryDate <= currentDate;
  });
}

if(timeFrame === '30 days')
{
  startDate.setDate(currentDate.getDate() - 30);
  // Filter data based on the date range (from startDate to currentDate)
 filteredData = spendPerDay.filter((entry) => {
    const entryDate = new Date(entry.DateSaved);
    return entryDate >= startDate && entryDate <= currentDate;
  });
}
if(timeFrame === '90 days')
{ 
  startDate.setDate(currentDate.getDate() - 90);
  // Filter data based on the date range (from startDate to currentDate)
 filteredData = spendPerWeek.filter((entry) => {
    const entryDate = new Date(entry.DateSaved);
    return entryDate >= startDate && entryDate <= currentDate;
  });}
if(timeFrame === '365 days')
{{ 
  startDate.setDate(currentDate.getDate() - 365);
  // Filter data based on the date range (from startDate to currentDate)
 filteredData = spendPerWeek.filter((entry) => {
    const entryDate = new Date(entry.DateSaved);
    return entryDate >= startDate && entryDate <= currentDate;
  });}}

 console.log('filteredData ',filteredData)
 const firstIndex = 0;
 const lastIndex = filteredData.length - 1;
const profit = filteredData[lastIndex].TotalValue -filteredData[firstIndex].TotalValue ;

setPeriode(timeFrame)
setProfitLoss(profit)


const TotalValueDataset = {
  label: 'Total Value',
  data: filteredData.map((entry) => entry.TotalValue),
  fill: false,
  borderColor: 'rgba(75, 192, 192, 1)',
};

const costDataset = {
  label: 'Total Cost',
  data: filteredData.map((entry) => entry.TotalCost), // Assuming this is the property for paid price
  fill: false,
  borderColor: 'rgba(192, 75, 75, 1)', // You can choose a different color
};

setChartData({
  labels: filteredData.map((entry) => entry.DateSaved),
  datasets: [TotalValueDataset, costDataset],
});

  };




  // Set the width and height of the canvas
  const canvasWidth = 150; // Adjust this value as needed
  const canvasHeight = 100; // Adjust this value as needed

  const divStyle = {
    width: '50%', // Adjust the width as needed
    height: '40%', // Adjust the height as needed
    border: '1px solid #ddd',
    borderRadius: '5px',
    padding: '10px',
  };

  return (
    <div>
      <p>just testing</p>
      <h2>Overall Performance</h2>
      <h3> {periode} - ${profitLoss} </h3>
      <h3>Spent this month : ${cost}</h3>
      <div>
        <label>Select Collection: </label>
        <select onChange={handleCollectionChange} value={selectedCollection ? selectedCollection.id : ''}>
          <option value="">All Collection</option>
          {collections.map((collection) => (
            <option key={collection.id} value={collection.id}>
              {collection.name}
            </option>
          ))}
        </select>
      </div>
      <div className='flex-h'>
        <button onClick={() => filterData('7 days')}>7 days</button>
        <button onClick={() => filterData('30 days')}>30 days</button>
        <button onClick={() => filterData('90 days')}>90 days</button>
        <button onClick={() => filterData('365 days')}>365 days</button>
      </div>
      <div style={divStyle}>
        <canvas ref={chartRef} width={canvasWidth} height={canvasHeight}></canvas>
      </div>
    </div>
  );
};

export default LiveCollectionCharts;
